import styled from 'styled-components'
import { grid, GridProps, padding, PaddingProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

const shouldForwardProp = (prop: string) =>
  !['gridTemplateColumns'].includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<GridProps & PaddingProps>`
  display: grid;
  width: 100%;
  gap: ${themeGet('space.3')}px;
  border-radius: 12px;
  background-color: ${themeGet('colors.background.screenContrast')};

  ${grid}
  ${padding}
`
